import { combineReducers } from 'redux'
import { MobileMenuReducer, ActiveMenuReducer, AppAlertsReducer, RoleReducer } from './'
import authSlice from './authSlice'

export const rootReducer = combineReducers({
  mobileMenu: MobileMenuReducer,
  activeMenu: ActiveMenuReducer,
  appAlert: AppAlertsReducer,
  auth: authSlice,
  role: RoleReducer,
})
